import { DataType, MenuSectionType, MenuType } from "../types/lib/types";

export const getMenuItem = (menu: MenuType, layerId: string) => {

  let result: DataType | null = null;

  const searchItem = (items: MenuType) => {

    for (const key in items) {

      if (items[key].type === "data" && items[key].id === layerId) {
        result = items[key];

      } else if (items[key].type === "category") {
        searchItem(items[key].items);
      }
    }
  }

  searchItem(menu);

  return result as DataType | null;
}

export const getMenuItemByTileId = (menu: MenuType, tileId: string) => {

  let result: DataType | null = null;

  const searchItem = (items: MenuType) => {

    for (const key in items) {
      
      if (items[key].type === "data" && items[key].tileId === tileId) {
        result = items[key];

      } else if (items[key].type === "category") {
        searchItem(items[key].items);
      }
    }
  }

  searchItem(menu);

  return result as DataType | null;
}

export const getMenuItemFromMenus = (menus: MenuSectionType | undefined, tileId: string) => {

  let result: DataType | null = null;

  for (const key in menus) {
    const items = menus[key].items;
    const item = getMenuItemByTileId(items, tileId);
    
    if (item) {
      result = item;
    }
  }

  return result;
}
